import { send } from "./auth";

/* ══ 조직(`crates/api/src/orgs.rs` · `docs/decisions/org.md`) ══
   조직에 묶인 프로젝트는 그 조직 멤버만 보고, GUEST 는 읽기만 한다. 판정은 서버(scope.rs) 한 곳이다 —
   화면은 역할에 따라 단추를 그릴지만 고른다(눌러도 서버가 다시 본다). */

export type OrgRole = "OWNER" | "USER" | "GUEST";
export const ORG_ROLES: OrgRole[] = ["OWNER", "USER", "GUEST"];

export type Org = {
  id: string;
  name: string;
  createdBy: string;
  createdAt: string;
  memberCount: number;
  /** 이 사람의 역할 — 관리자라도 멤버가 아니면 `null`. */
  myRole: OrgRole | null;
  projects: { id: string; name: string }[];
  /** 조직마다 git 연결은 하나 — 없으면 `null`. */
  gitConnection: { id: string; label: string; provider: string } | null;
};

export type OrgMember = {
  userId: string;
  username: string;
  displayName: string | null;
  role: OrgRole;
  addedAt: string;
};

const enc = encodeURIComponent;

export const orgApi = {
  list: () => send<{ orgs: Org[] }>("GET", "/orgs").then((r) => r.orgs),
  create: (name: string) => send<Org>("POST", "/admin/orgs", { name }),
  /** 칸이 없으면 그대로, `gitConnectionId: null` 이면 연결을 뗀다. */
  update: (id: string, b: { name?: string; gitConnectionId?: string | null }) => send<Org>("PATCH", `/orgs/${enc(id)}`, b),
  remove: (id: string) => send<null>("DELETE", `/admin/orgs/${enc(id)}`),
  /** 프로젝트를 **통째로** 바꾼다 — 빠진 것은 「조직 없음」으로 돌아간다. */
  setProjects: (id: string, projectIds: string[]) => send<Org>("PUT", `/admin/orgs/${enc(id)}/projects`, { projectIds }),
  members: (id: string) => send<{ members: OrgMember[] }>("GET", `/orgs/${enc(id)}/members`).then((r) => r.members),
  /** 더하기와 역할 바꾸기가 한 문이다 — 아이디로 받는다. */
  setMember: (id: string, username: string, role: OrgRole) =>
    send<{ members: OrgMember[] }>("PUT", `/orgs/${enc(id)}/members`, { username, role }).then((r) => r.members),
  removeMember: (id: string, userId: string) =>
    send<{ members: OrgMember[] }>("DELETE", `/orgs/${enc(id)}/members/${enc(userId)}`).then((r) => r.members),
};
